import { createContext, useContext } from 'react';

// Kept apart from ImpersonationProvider so readers (e.g. AnalyticsProvider)
// don't import its dependencies, which import AnalyticsProvider back.
// isImpersonating is null until the URL params or the cookie have been checked.
export const ImpersonationContext = createContext<
  { isImpersonating: boolean | null } | undefined
>(undefined);

export const useIsImpersonating = (): boolean | null => {
  const status = useContext(ImpersonationContext);
  if (!status) {
    throw new Error(
      'useIsImpersonating must be used within ImpersonationProvider',
    );
  }
  return status.isImpersonating;
};
